import Box from "@mui/material/Box";
import MUIDataTable from "mui-datatables";

import TableSkeleton from "../../../components/skeletons/TableSkeleton";

import { getColumns, getOptions } from "./config";

import { useTranslation } from "react-i18next";
import { useGetAwaitingCompaniesQuery } from "../companiesApiSlice";

const Awaiting = () => {
	const { t } = useTranslation();
	const { data, error, isLoading } = useGetAwaitingCompaniesQuery();

	if (isLoading) {
		return (
			<Box sx={{ mt: "64px" }}>
				<TableSkeleton />
			</Box>
		);
	}

	const columns = getColumns(t);
	const options = getOptions(t);

	return (
		<MUIDataTable
			className="mui-data-table awaiting-table no-bar center-all-cells"
			data={data.companies}
			columns={columns}
			options={options}
		/>
	);
};

export default Awaiting;
